"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _api = require("@react-google-maps/api");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../theme");
var _templateObject;
var borderRadius = _theme.theme.shape.borderRadius,
  spacing = _theme.theme.spacing;
var Styled = (0, _styledComponents["default"])(_api.LoadScript)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  input {\n    box-sizing: border-box;\n    border: 1px solid transparent;\n    width: 240px;\n    height: 32px;\n    margin-top: ", "px;\n    padding: 0 ", "px;\n    border-radius: ", "px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    font-size: 16px;\n    outline: none;\n    text-overflow: ellipses;\n  }\n"])), spacing(3), spacing(), borderRadius);
exports.Styled = Styled;